(function () {
  'use strict';
  function initialize() {
    const shopify = window.Shopify;
    const privacy = shopify && shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return;
    document.querySelectorAll('form.sm-general-enquiry').forEach(function (form) {
      if (form.dataset.smEnquiryBound) return;
      form.dataset.smEnquiryBound = 'true';
      const key = 'sm-ga4-enquiry:' + location.pathname;
      form.addEventListener('submit', function (event) {
        if (!event.isTrusted || !form.checkValidity() || privacy.analyticsProcessingAllowed() !== true) return;
        try { sessionStorage.setItem(key, String(Date.now())); } catch (_) {}
      }, true);
      if (!form.querySelector('[data-sm-general-enquiry-success]')) return;
      if (privacy.analyticsProcessingAllowed() !== true) {
        form.dataset.smEnquiryTracking = 'analytics-consent-denied';
        return;
      }
      let pending;
      try { pending = Number(sessionStorage.getItem(key)); } catch (_) { return; }
      const age = Date.now() - pending;
      if (!pending || age < 0 || age > 600000) return;
      const leads = window.ShoeMedicLeadAnalytics;
      if (!leads || typeof leads.formSuccess !== 'function') {
        form.dataset.smEnquiryTracking = 'lead-sender-unavailable';
        return;
      }
      try { sessionStorage.removeItem(key); } catch (_) { return; }
      form.dataset.smEnquiryTracking = leads.formSuccess('general_enquiry');
    });
  }
  if (window.Shopify && !Shopify.customerPrivacy && typeof Shopify.loadFeatures === 'function') {
    Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], initialize);
  } else { initialize(); }
}());
